import { render, staticRenderFns } from "./DatenschutzView.vue?vue&type=template&id=99e3abea&scoped=true&"
import script from "./DatenschutzView.vue?vue&type=script&lang=js&"
export * from "./DatenschutzView.vue?vue&type=script&lang=js&"
import style0 from "./DatenschutzView.vue?vue&type=style&index=0&id=99e3abea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e3abea",
  null
  
)

export default component.exports